<template>
  <div
    class="tabulka__bodyExtendable"
    :class="{ opened: opened, closed: !opened }"
  >
    <div class="tabulka__bodyExtendable__top">
      <select
        v-if="!hasAnyPurchasedCampaigns"
        class="tabulka__bodyExtendable__top__product"
        v-model="form.productId"
      >
        <option
          v-for="product in availableProducts"
          :key="`ProductCampaignRow-${product.id}`"
          :value="product.id"
        >
          {{ product.name }}
        </option>
      </select>
      <div v-else class="ProductCampaignRow__title">
        {{ campaign.product.name }}
      </div>
      <div class="tabulka__bodyExtendable__top__productInfo">
        {{ campaign.product.productCategory.name }}, Cost:
        {{ campaign.items[0].oldProductCost || campaign.product.cost }} €,
        Price:
        {{ campaign.items[0].oldProductPrice || campaign.product.price }} €
      </div>
      <div class="tabulka__bodyExtendable__top__toggle" @click="toggleBody">
        <div class="tabulka__bodyExtendable__top__toggle__img"></div>
      </div>
      <div
        v-if="archive"
        class="tabulka__bodyExtendable__top__duplicateCampaignButton"
        @click="duplicateFromArchive"
      >
        Create as a new campaign
      </div>
      <div
        v-if="!hasAnyPurchasedCampaigns"
        class="tabulka__bodyExtendable__top__delete"
        @click="deleteCampaign"
      >
        Delete campaign
      </div>
      <div
        v-if="campaign.totalPrice"
        class="tabulka__bodyExtendable__top__price"
      >
        Total price {{ campaign.totalPrice | numbersThousands | inCurrency }}
      </div>
      <div class="tabulka__bodyExtendable__top__round" v-if="archive">
        Round {{ campaign.turn }}
      </div>
      <!--      <div-->
      <!--        class="tabulka__bodyExtendable__top__duplicate"-->
      <!--        @click="$emit('duplicateCampaign')"-->
      <!--        v-if="!archive"-->
      <!--      >Duplicate campaign</div>-->
    </div>
    <div class="tabulka__bodyExtendable__body">
      <table>
        <thead>
          <td>
            <span>Mediatype</span>
            <SortButton
              row="adTypeId#adTypes#name"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Time</span>
          </td>
          <td>
            <span>Place</span>
          </td>
          <td>

            <span>Price</span>
            <SortButton
              row="computedPrice"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
        </thead>
        <MediatypeRow
          v-for="campaign in sortedDataAdvanced"
          :key="`MediaTypeRow-${campaign.id}`"
          :productId="form.productId"
          :campaign="campaign"
          :archive="archive"
          :editing="editing"
          @showNewCampaigns="showNewCampaigns"
          @editing="editingStarted"
          @finishEditing="finishEditing"
        />
      </table>

      <button
        class="tabulka__middleButton"
        @click="newCampaign"
        v-if="!archive"
        :disabled="this.editing"
        :title="
          this.editing
            ? this.$t('messages.campaign.adding-locked-while-editing')
            : ''
        "
      >
        Add mediatype
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani

import MediatypeRow from "@/components/game/table/MediatypeRow.vue";

export default {
  name: "ProductCampaignRow",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
    MediatypeRow,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    archive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: true,
      currentSortRow: "id",
      form: {
        productId: this.campaign.product.id,
      },
      editingVar: false,
    };
  },
  methods: {
    toggleBody: function () {
      this.opened = !this.opened;
    },
    async newCampaign() {
      this.editingVar = true;
      await this.$store.dispatch("addTempCampaign", this.form.productId);
    },
    async deleteCampaign() {
      await this.$store.dispatch("deleteCampaigns", this.form.productId);
    },
    duplicateFromArchive() {
      this.$store.dispatch("duplicateFromArchive", {
        turn: this.campaign.turn,
        productId: this.campaign.product.id,
      });
      this.showNewCampaigns();
      if (this.$router.currentRoute.path != "/game/SetCampaigns") {
        this.$router.push("/game/SetCampaigns");
      }
    },
    showNewCampaigns() {
      this.$emit("showNewCampaigns");
    },
    refreshComponent() {
      this.$forceUpdate();
    },
    editingStarted() {
      this.editingVar = true;
    },
    finishEditing() {
      this.editingVar = false;
    },
  },
  computed: {
    ...mapGetters({
      products: "teamProducts",
      productsWithoutCampaign: "productsWithoutCampaign",
      adTypes: "gameAdTypes",
    }),
    availableProducts() {
      return [
        this.products.find((product) => product.id === this.form.productId),
        ...(!this.archive ? this.productsWithoutCampaign : []),
      ];
    },
    sourceData() {
      return this.campaign.items;
    },
    hasAnyPurchasedCampaigns() {
      return !!this.campaign.items.find((campaign) => !campaign.isTemp);
    },
    sortedDataAdvanced() {
      var newArray = this.sortedData.slice();
      newArray.map((elem, index) => {
        if (elem.isTemp != undefined && elem.isTemp) {
          newArray.splice(index, 1);
          newArray.push(elem);
        }
      });
      return newArray;
    },
    isThereTempCampaign() {
      var found = false;
      for (var i = 0; i < this.sourceData.length; i++) {
        if (this.sourceData[i].isTemp == true) {
          found = true;
          break;
        }
      }
      return found;
    },
    editing() {
      return this.isThereTempCampaign ? true : this.editingVar;
    },
  },
  watch: {
    "form.productId"(productId, oldProductId) {
      this.$store.dispatch("changeTempCampaignsProductId", {
        productId,
        oldProductId,
      });
    },
  },
};
</script>
